import { NavLink } from "react-router-dom";

const ITEMS = [
  { to: "/controls", label: "Aktywna kontrola", end: true },
  { to: "/controls/history", label: "Historia", end: false },
];

export function TagsSubnav() {
  return (
    <nav className="subnav" aria-label="Kontrole" data-testid="tags-subnav">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            isActive ? "subnav__link subnav__link--active" : "subnav__link"
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
